<template>
    <div class="mx-auto mt-[50px] flex flex-col sm:flex-row w-[95%] sm:w-[70%] lg:w-[85%] sm:items-center pt-4 pb-4">
        <div class="w-[100px] shrink-0 mt-6">
            <img
                src="/images/campaigns/logo.svg"
                class="w-full"
                alt="Nova logo"
            />
        </div>

        <p 
            class="sm:ml-10 mt-6 text-[14px] lg:text-[16px] lg:leading-loose text-[#141430]" 
            v-html="$t('campaign_version_one.footer_text')"
        ></p>
    </div>
</template>
